/**
 * A new tab showing "One moment…", opened during the click and pointed somewhere once the server
 * answers. Opening it after the await instead would be a popup the browser did not see a click for,
 * and every blocker would stop it - the one case where the button appears to do nothing at all.
 *
 * <p>Not 'noopener' in the features: with it, window.open returns null by specification even though
 * it did open a tab - so callers took that for a blocked popup, navigated this tab away and left the
 * new one on about:blank. The same protection is applied by hand instead: cutting opener before the
 * tab is sent anywhere means the partner's page can never reach back into this one.
 */
export function openHoldingTab(title: string): Window | null {
  const tab = window.open('', '_blank')
  if (tab) {
    tab.opener = null
    // And the other half of what 'noreferrer' did: the partner is not told which page sent them.
    const noReferrer = tab.document.createElement('meta')
    noReferrer.name = 'referrer'
    noReferrer.content = 'no-referrer'
    tab.document.head.appendChild(noReferrer)
    // Something to look at for the few seconds the server takes, rather than a white page.
    tab.document.title = title
    tab.document.body.style.cssText =
      'margin:0;display:flex;align-items:center;justify-content:center;height:100vh;font-family:system-ui,sans-serif;color:#5b6172'
    tab.document.body.textContent = 'One moment…'
  }
  return tab
}
